export const products = {
    "sac-viral-compatible-tiktok-neon": {
        id: "neon",
        slug: "sac-viral-compatible-tiktok-neon",
        name: "Sac Viral Compatible TikTok (Gamme NEON)",
        shortDesc: "Le sac qui rend vos colis viraux sur TikTok.",
        fullDesc: "Ne soyez plus un vendeur invisible. Avec la gamme NEON, vos colis sautent aux yeux dès l'arrivée. Intègre notre technologie de parfum micro-encapsulé pour un effet Waouh garanti à l'ouverture. Parfait pour les créateurs de contenu TikTok Shop.",
        price: 12.99,
        originalPrice: 24.99,
        reviews: 124,
        rating: 4.9,
        tag: "VIRAL TIKTOK",
        tagColor: "#ff0050",
        pricing: {
            30: { S: 12.99, M: 14.99, L: 16.99 },
            100: { S: 35.99, M: 39.99, L: 43.99 },
            300: { S: 89.99, M: 99.99, L: 109.99 }
        },
        features: [
            "Couleur Flashy (Visible à 100m)",
            "Parfum Fruité Intégré",
            "Indéchirable (60 microns)",
            "Booste les posts TikTok/Insta"
        ],
        images: [
            "/assets/sac-vinted-hero-emballage-parfume-3d.webp",
            "/assets/neon-stack.webp",
            "/assets/neon-closeup.webp"
        ],
        seo: {
            title: "Sac Viral Compatible TikTok | Emballage Colis Neon Parfumé | Unbox Creator",
            description: "Le fameux sac rose fluo pour percer sur TikTok. Emballage colis compatible Vinted, parfumé, ultra-résistant et imperméable. Devenez inoubliable.",
            keywords: "sac viral tiktok, emballage compatible vinted, colis rose fluo, pochette parfumée, unboxing viral"
        }
    },
    "pochette-premium-compatible-vinted-zipper": {
        id: "zipper",
        slug: "pochette-premium-compatible-vinted-zipper",
        name: "Pochette Premium Compatible Vinted (Gamme ZIPPER)",
        shortDesc: "L'emballage boutique de luxe, réutilisable.",
        fullDesc: "Faites passer votre boutique au niveau supérieur. La finition givrée et la fermeture adhésive sécurisée donnent à vos envois une allure de marque de luxe. Réutilisable par vos clients = Publicité gratuite. Idéal pour les vendeurs Vinted Pro.",
        price: 12.99,
        originalPrice: 24.99,
        reviews: 89,
        rating: 5.0,
        tag: "LUXE & PRO",
        tagColor: "#00f2ea",
        pricing: {
            30: { S: 12.99, M: 14.99, L: 16.99 },
            100: { S: 35.99, M: 39.99, L: 43.99 },
            300: { S: 89.99, M: 99.99, L: 109.99 }
        },
        features: [
            "Fermeture Adhésive Sécurisée",
            "Aspect Givré Premium",
            "Bande adhésive inviolable",
            "Réutilisable (Écologique)"
        ],
        images: [
            "/assets/sac-vinted-zipper-pochette-expedition-premium.webp",
            "/assets/pochette-expedition-vinted-systeme-zip-securise.webp"
        ],
        seo: {
            title: "Pochette Premium Compatible Vinted | Sac Réutilisable | Unbox Creator",
            description: "Pochette expédition avec fermeture adhésive compatible Vinted. Aspect givré 'boutique de luxe'. Idéal pour vêtements, lingerie et créateurs. Qualité 60 microns.",
            keywords: "pochette compatible vinted, sac zip vetement, emballage luxe réutilisable, pochette givrée"
        }
    },
    "enveloppe-ecommerce-compatible-shopify": {
        id: "unicolor",
        slug: "enveloppe-ecommerce-compatible-shopify",
        name: "Enveloppe E-commerce (Gamme UNICOLOR)",
        shortDesc: "Votre identité de marque à petit prix.",
        fullDesc: "L'alternative parfaite aux sachets gris tristes pour votre boutique Shopify ou WooCommerce. Choisissez Votre couleur. Créez Votre marque. La qualité professionnelle 60 microns Unbox Creator, sans fioritures mais avec style.",
        price: 9.99,
        originalPrice: 19.99,
        reviews: 215,
        rating: 4.8,
        tag: "BEST SELLER",
        tagColor: "#ffee00",
        pricing: {
            30: { S: 9.99, M: 11.99, L: 14.99 },
            100: { S: 24.99, M: 29.99, L: 39.99 },
            300: { S: 69.99, M: 79.99, L: 99.99 }
        },
        colors: [
            { name: "Cyan Océan", value: "cyan", hex: "#00f2ea", image: "/assets/unicolor-cyan.webp" },
            { name: "Rose Bonbon", value: "pink", hex: "#ff0050", image: "/assets/unicolor-rose.webp" },
            { name: "Jaune Électrique", value: "yellow", hex: "#ffee00", image: "/assets/unicolor-jaune.webp" },
            { name: "Noir Minuit", value: "black", hex: "#000000", image: "/assets/unicolor-noir.webp" },
            { name: "Blanc Pur", value: "white", hex: "#ffffff", image: "/assets/unicolor-blanc.webp" },
            { name: "Bleu Roi", value: "blue", hex: "#1e40af", image: "/assets/unicolor-bleu.webp" },
            { name: "Rouge Passion", value: "red", hex: "#dc2626", image: "/assets/unicolor-rouge.webp" },
            { name: "Vert Gazon", value: "green", hex: "#16a34a", image: "/assets/unicolor-vert.webp" },
            { name: "Orange Vitaminé", value: "orange", hex: "#f97316", image: "/assets/unicolor-orange.webp" },
            { name: "Bordeaux Chic", value: "bordeaux", hex: "#881337", image: "/assets/unicolor-bordeaux.webp" }
        ],
        features: [
            "10 Couleurs Disponibles",
            "Rapport Qualité/Prix Imbattable",
            "Parfait pour le Branding",
            "Compatible Shopify/Wix/Etsy"
        ],
        images: [
            "/assets/unicolor-cyan.webp", // Default image matches first color
            "/assets/pochette-vinted-emballage-colis-pack-parfume.webp"
        ],
        seo: {
            title: "Enveloppe Expédition Couleur | Compatible E-commerce & Vinted",
            description: "Enveloppes d'expédition opaques en couleur. Moins cher que le carton. Compatible Shopify, Etsy et Vinted. Idéal pour branding fort.",
            keywords: "enveloppe plastique couleur, emballage e-commerce, compatible shopify, sac expedition couleur"
        }
    }
};
